var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error"},[_c('div',{staticClass:"pic"},[_c('img',{attrs:{"src":require("@/assets/images/404.svg")}})]),_c('h2',[_vm._v("很抱歉，您要访问的页面不存在！")])])
}]

export { render, staticRenderFns }